export enum CardNames {
  ROCK = 'rock',
  PAPER = 'paper',
  SCISSORS = 'scissors'
}

export type PlayerCards = Record<CardNames, number>;
